import axios from "axios";
import { LocalStorageHandler } from "@/utils/LocalStorageHandler";
const localStorageHandler = new LocalStorageHandler();

const encodeFilterValue = (filterStr) => {
  const comps = filterStr.split(":");
  if (comps.length < 3) {
    throw new Error(
      `Invalid filter string format: "${filterStr}". Expected format "field:operator:value".`
    );
  }

  if (comps[2].includes(";")) {
    const encodedValue = encodeURIComponent(encodeURIComponent(comps[2]));
    // If the value contains semicolons, we need to double encode it to ensure it is correctly parsed by the backend. This is because the backend uses semicolons as delimiters for multiple filter values, so we need to ensure that any semicolons in the value itself are not treated as delimiters.
    filterStr = `${comps[0]}:${comps[1]}:${encodedValue}`;
  }

  return filterStr;
};

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: (params) => {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
      if (value === null || value === undefined) {
        continue;
      }

      if (key === "filter") {
        if (Array.isArray(value)) {
          value.forEach((v) => {
            searchParams.append(key, encodeFilterValue(v));
          });
        } else {
          searchParams.append(key, encodeFilterValue(value));
        }
      } else if (Array.isArray(value)) {
        throw new Error(
          `Unsupported array parameter for key "${key}", value "${value}". Only "filter" arrays are supported.`
        );
      } else {
        searchParams.append(key, value);
      }
    }

    return searchParams.toString();
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorageHandler.getAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Axios request error:", error);
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    // There are other props in the response like config, headers, status, statusText, etc. For now, we just return data.
    return response.data;
  },
  (error) => {
    console.error("Axios response error:", error);
    return Promise.reject(error);
  }
);

export default apiClient;
